import "./loadingOverlay.sass";

/**
 * Componente de overlay de carga que cubre toda la pantalla
 * Muestra un spinner centrado con fondo semitransparente durante operaciones asíncronas
 * 
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.show - Controla la visibilidad del overlay
 * @param {string} props.backgroundColor - Color de fondo del overlay (opcional)
 * 
 * @returns {JSX.Element|null} Overlay con spinner o null si no debe mostrarse
 */
export default function LoadingOverlay({ show, backgroundColor }) {
  // Renderizado condicional: solo muestra el overlay cuando show es true
  if (!show) return null;

  return (
    // Overlay de pantalla completa con fondo semitransparente
    <div className="calculating-overlay" style={{ backgroundColor }}>
      <div className="calculating-spinner"></div>
    </div>
  );
}